import { emailSendModalActions, SendEmailStep } from '@/ModalWindows/EmailSendModal/services/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { salesPageSelectors } from '@/Pages/Sales/services';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';
import { useEmailSendModalActions } from '@/ModalWindows/EmailSendModal/hooks/useEmailSendModalActions';

export const useSelectTemplateModal = () => {
  const dispatch: AppDispatch = useDispatch();

  const selectedSale = useSelector(salesPageSelectors.selectedSale);
  const selectedSalesIds = useSelector(salesPageSelectors.selectedSalesIds);
  const documentType = useSelector(emailSendModalSelectors.documentType);
  const selectedTypeNumbers = useSelector(emailSendModalSelectors.selectedTypeNumbers);
  const selectedTemplate = useSelector(emailSendModalSelectors.selectedEmailTemplate);

  const { getEmailPreviewForOrder, sendEmailForOrders } = useEmailSendModalActions();

  const getSendEmailStep = () => {
    if (!documentType) return null;

    if (selectedTypeNumbers.length == 0) return SendEmailStep.CreateDocument;

    if (selectedTypeNumbers.length > 1) return SendEmailStep.SelectDocumentNumber;

    return null;
  };

  const sendEmail = () => {
    if (!selectedTemplate) return;

    if (selectedSalesIds.length > 1) {
      sendEmailForOrders(selectedSalesIds, selectedTemplate.guid);
      return;
    }

    const step = getSendEmailStep();

    if (step) {
      dispatch(emailSendModalActions.setSendEmailStep(step));
      return;
    }

    // Preview or send directly
    const showPreview = selectedTemplate.previewBeforeSending || !selectedSale?.buyerEmail;

    if (showPreview && selectedSale) {
      getEmailPreviewForOrder(selectedSale.id, selectedTemplate.guid);
    } else {
      sendEmailForOrders(selectedSalesIds, selectedTemplate.guid);
    }
  };

  return {
    sendEmail,
  };
};
